import { IUserMilestone } from '../../IUserMilestone';

export const OPENING_ORDER_DISCOUNT_MODAL_SEEN =
  'OPENING_ORDER_DISCOUNT_MODAL_SEEN' as IUserMilestone.RetailerMilestone;
